import { render, staticRenderFns } from "./ListMailTemplatesPage.vue?vue&type=template&id=2ad39a64&scoped=true&"
import script from "./ListMailTemplatesPage.vue?vue&type=script&lang=js&"
export * from "./ListMailTemplatesPage.vue?vue&type=script&lang=js&"
import style0 from "./ListMailTemplatesPage.vue?vue&type=style&index=0&id=2ad39a64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad39a64",
  null
  
)

export default component.exports